import { map, isObject, isDate, isString } from 'lodash';

const getIdsOrValuesFromCollection = (value) => {
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return undefined;
    }

    if (isDate(value[0])) {
      return value;
    }

    if (isObject(value[0])) {
      return map(value, 'id');
    }

    return value;
  }

  if (isString(value) && value.length === 0) {
    return undefined;
  }

  return value;
};

export default getIdsOrValuesFromCollection;
